<template>
  <div
    :style="{
      'background-position-x': backgroundPositionX,
      width: `${size}px`,
      height: `${size}px`,
      'background-color': bgColor,
    }"
    :class="[$style.star, { [$style.blue]: color === 'blue' }]"
  ></div>
</template>

<script>
export default {
  name: 'Star',

  props: {
    color: {
      type: String,
      default: 'yellow', // or blue
    },
    ratio: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 22,
    },
    bgColor: {
      type: String,
      default: '#EAE9E3',
    },
  },

  computed: {
    backgroundPositionX() {
      return `-${this.size - this.size * this.ratio}px`
    },
  },
}
</script>

<style lang="scss" module>
.star {
  background-image: url('~/assets/star/yellow-star-bg.png');
  background-repeat: no-repeat;
  background-size: contain;
  mask: url('~/assets/star/star.svg') no-repeat center;
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;
}

.blue {
  background-image: url('~/assets/star/blue-star-bg.png') !important;
}
</style>
